import { useId } from 'react'

import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Success Checkmark SVG Icon
 */
export const SuccessCheckmark: React.FC<AccessibleSVGProps> = (props) => {
  const filterId = useId()

  return (
    <AccessibleSVG width="100%" height="100%" viewBox="0 0 185 185" {...props}>
      <g>
        <g filter={`url(#${filterId})`}>
          <circle cx="92.5" cy="83.5" r="56.5" fill="#00D65B" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.259 69.3474L83.3443 113.519L58.7411 89.323L69.2589 78.6283L83.3443 92.4808L117.741 58.6527L128.259 69.3474Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="185"
          height="185"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_8235_14232"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.839216 0 0 0 0 0.356863 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8235_14232"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.839216 0 0 0 0 0.356863 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_8235_14232"
            result="effect2_dropShadow_8235_14232"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8"
            operator="dilate"
            in="SourceAlpha"
            result="effect3_dropShadow_8235_14232"
          />
          <feOffset dy="9" />
          <feGaussianBlur stdDeviation="14" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.839216 0 0 0 0 0.356863 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_8235_14232"
            result="effect3_dropShadow_8235_14232"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_8235_14232"
            result="shape"
          />
        </filter>
      </defs>
    </AccessibleSVG>
  )
}
